class CustomFestivalHeader extends HTMLElement {
  connectedCallback() {
    this.drawer = this.querySelector('[data-header-drawer]');
    this.closeButton = this.querySelector('[data-header-close]');
    this.headerGroup = document.querySelector('#header-group');
    this.closeButton?.addEventListener('click', () => this.closeDrawer());
    this.addEventListener('keydown', (event) => {
      if (event.key === 'Escape') this.closeDrawer();
    });
    this.drawer?.addEventListener('toggle', () => {
      document.documentElement.classList.toggle('custom-header-drawer-open', this.drawer.open);
    });

    this.updateHeaderGroupHeight = () => {
      if (!this.headerGroup) return;

      const height = this.classList.contains('custom-header--sticky')
        ? Math.round(this.headerGroup.getBoundingClientRect().height)
        : 0;
      document.body.style.setProperty('--header-group-height', `${height}px`);
    };

    this.headerGroupResizeObserver = new ResizeObserver(() => this.updateHeaderGroupHeight());

    if (this.headerGroup) {
      this.headerGroupResizeObserver.observe(this.headerGroup);
      requestAnimationFrame(this.updateHeaderGroupHeight);
    }
  }

  disconnectedCallback() {
    document.documentElement.classList.remove('custom-header-drawer-open');
    this.headerGroupResizeObserver?.disconnect();
  }

  closeDrawer() {
    if (this.drawer) this.drawer.open = false;
  }
}

if (!customElements.get('custom-festival-header')) {
  customElements.define('custom-festival-header', CustomFestivalHeader);
}
